module.exports = __webpack_public_path__ + "img/gift-7.faf7f0b5.jpg";